<template>
  <div class="app-main-content credit-business-manage-native">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%" @tab-click="handleClick">
        <el-tab-pane v-if="$checkPermission(['tab_CreditManage_tabLockList'])" :label="$t('CargoMsg.Cargo_LockTheBill')" name="tabLock" :lazy="true">
          <tab-lock ref="tabLock" />
        </el-tab-pane>
        <el-tab-pane v-if="$checkPermission(['tab_CreditManage_tabSpecialApprovalList'])" :label="$t('CargoMsg.Cargo_SpecialApproval')" name="tabSpecialApproval" :lazy="true">
          <tab-special-approval ref="tabSpecialApproval" />
        </el-tab-pane>
        <el-tab-pane v-if="$checkPermission(['tab_CreditManage_tabCreditLogList'])" :label="$t('CargoMsg.Cargo_Log')" name="tabCreditLog" :lazy="true">
          <tab-credit-log ref="tabCreditLog" />
        </el-tab-pane>
        <el-tab-pane v-if="$checkPermission(['tab_CreditManage_tabSettleAccountList'])" :label="$t('CargoMsg.Cargo_SettleAccountsTo')" name="tabCreditControl" :lazy="true">
          <tab-credit-control ref="tabCreditControl" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import tabLock from './components/CreditBusinessManage/tabLock'
import tabSpecialApproval from './components/CreditBusinessManage/tabSpecialApproval'
import tabCreditLog from './components/CreditBusinessManage/tabCreditLog'
import tabCreditControl from './components/CreditBusinessManage/tabCreditControl'

export default {
  name: 'CreditBusinessManage',
  components: { tabLock, tabSpecialApproval, tabCreditLog, tabCreditControl },
  data() {
    return {
      activeTabName: 'tabLock'
    }
  },
  beforeMount() {
    const tabLockList = this.$checkPermission(['tab_CreditManage_tabLockList'])
    const tabSpecialApprovalList = this.$checkPermission(['tab_CreditManage_tabSpecialApprovalList'])
    const tabCreditLogList = this.$checkPermission(['tab_CreditManage_tabCreditLogList'])
    const tabSettleAccountList = this.$checkPermission(['tab_CreditManage_tabSettleAccountList'])
    if (!tabLockList) {
      if (tabSpecialApprovalList) {
        this.activeTabName = 'tabSpecialApproval'
      } else {
        if (tabCreditLogList) {
          this.activeTabName = 'tabCreditLog'
        } else if (tabSettleAccountList) {
          this.activeTabName = 'tabCreditControl'
        } else {
          this.activeTabName = ''
        }
      }
    }
  },
  methods: {
    // tab 页签点击事件
    handleClick(tab, event) {
      console.log(tab, event)
      if (tab.name === this.activeTabName && this.$refs[this.activeTabName]) {
        this.$refs[this.activeTabName].fetchOrderRequirement()
      }
    }
  }
}
</script>

<style scoped>

</style>
